import axios from 'axios'
import {catchErrors} from 'uicommon/errors'
import Qs from 'qs'

const service = axios.create({
    baseURL: window.location.origin,
    paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})
})

service.interceptors.request.use(function (config) {
    let token = sessionStorage.getItem('token')
    if (token) config.headers.Authorization = token

    return config
}, function (error) {
    if(error.response.data.errors && !error.response.data.propertyErrors) error.response.data.propertyErrors = error.response.data.errors
    if(error.response.data.message && !error.response.statusText) error.response.statusText = error.response.data.message

    return Promise.reject(error)
})
// response
service.interceptors.response.use(
    response => {
        return response.data
    }, error => {
        return catchErrors(error)
    }
)

export default service
